import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Column from "./Column";

interface SortableColumnProps {
  id: string;
  column: any;
  tasks: any[];
  onTitleChange: (newTitle: string) => void;
  onDelete: () => void;
  isInitialLoading?: boolean;
  isLoadingMore?: boolean;
  refreshData?: () => void;
  onLoadMore?: () => void;
  hasMore?: boolean;
  onTaskUpdate?: (
    taskId: string,
    updatedTask: any | null,
    newColumnId?: string
  ) => void;
  canEditColumn?: boolean;
  style?: React.CSSProperties;
}

const SortableColumn: React.FC<SortableColumnProps> = ({
  id,
  style,
  ...props
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    data: {
      type: "column",
    },
  });

  const sortableStyle = {
    ...style,
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  // Create drag handle props specifically for the column header
  // DO NOT spread listeners on the entire column
  const dragHandleProps = {
    ...attributes,
    // Only pass listeners to specific drag handle, not the entire column
    dragListeners: listeners,
  };

  return (
    <div
      ref={setNodeRef}
      style={sortableStyle}
      data-column-id={id}
      // Remove any drag-related props from the main container
    >
      <Column {...props} dragHandleProps={dragHandleProps} />
    </div>
  );
};

export default SortableColumn;
